import { IonContent, IonLoading, IonPage } from '@ionic/react'

import AdminHeader from '../../../components/header/admin-header'
import { ApprovalsListWrapper } from '../../../admin/approvals/components/approvals-list-wrapper'
import { BroadcastApprovalItem } from '../../../admin/approvals/components/broadcast-approval-item'
import { useApprovals } from '../../../admin/approvals/queries'
import { Card, CardContent } from '../../../components/ui/card'

function CampaignApprovalsPage() {
  const { data } = useApprovals({
    permission: 'admin',
    filter: 'broadcast',
  })
  const broadcasts = data?.pages.flatMap((d) => d.data)

  return (
    <IonPage>
      <AdminHeader title="Broadcast Approvals" showMenu />
      <IonContent>
        {broadcasts ? (
          broadcasts.length > 0 ? (
            <ApprovalsListWrapper>
              {broadcasts.map((approval) => (
                <BroadcastApprovalItem
                  key={approval.objectId}
                  broadcast={approval}
                />
              ))}
            </ApprovalsListWrapper>
          ) : (
            <div className="mx-auto max-w-md py-4">
              <Card>
                <CardContent>
                  There are no campaigns that need your approval.
                </CardContent>
              </Card>
            </div>
          )
        ) : (
          <IonLoading isOpen message="Loading campaign approvals..." />
        )}
      </IonContent>
    </IonPage>
  )
}

export { CampaignApprovalsPage }
